import { useState, useEffect } from "react";

/**
 * Hook for persisting theme state to localStorage
 * Automatically syncs state changes to storage and restores on mount
 *
 * @param {string} key - The localStorage key to use
 * @param {*} initialState - The initial state value if not in storage
 * @returns {Array} [state, setState] - Current state and setter function
 */
const usePersistTheme = (key, initialState) => {
  const [state, setState] = useState(() => {
    const storageValue = localStorage.getItem(key);

    if (storageValue) {
      return JSON.parse(storageValue);
    }

    return initialState;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
};

export default usePersistTheme;
